import { useEffect, useState } from "react";
import {
  useParams,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import AxiosService from "../utils/AxiosService";
import { KEY_NAME } from "../utils/KeyName";
import Loader from "../components/Loader/Loader";

const LegacyRedirector = ({ assumedType, explicitShortName }) => {
  const { entityType, shortName: paramShortName } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);

  const actualType = assumedType || entityType;
  const shortCode = explicitShortName || paramShortName;
  const hashStr = location.hash || "";

  // const isMask = shortCode === "masked" ? true : false;
  const isMask = hashStr.endsWith("@") || shortCode === "masked";

  // const actualShortName =
  //   shortCode === "masked"
  //     ? location.hash.split("/")[0].replace("#", "")
  //     : shortCode;
  const actualShortName = isMask
    ? hashStr.replace("#", "").replace("@", "").split("/")[0]
    : shortCode;

  const axiosService = new AxiosService();

  useEffect(() => {
    if (actualShortName === "page-not-found") {
      setHasError(true);
      return;
    }

    const fetchAndRedirect = async () => {
      try {
        let response;

        // 1. Wait for the correct API call to finish using 'await'
        switch (actualType) {
          case KEY_NAME.FUNDER:
            response = await axiosService.getFundersList(
              actualShortName,
              isMask,
            );
            break;
          case KEY_NAME.PUBLISHER:
            response = await axiosService.getPublishersList(
              actualShortName,
              isMask,
            );
            break;
          case KEY_NAME.INSTITUTION:
            response = await axiosService.getInstitutionsList(
              actualShortName,
              isMask,
            );
            break;
          default:
            throw new Error("Invalid entity type provided to redirector");
        }

        // Extract data from the successful response
        const data = response?.data?.data?.[0];

        // Check if data actually exists before proceeding
        // if (!data || !data.agencyId) {
        if (!data) {
          throw new Error("Data not found for this shortName");
        }

        // 2. Determine the Tab based on the old hash
        let tabParam = "Summary";
        if (location.hash.toLowerCase().includes("summary")) {
          tabParam = "Summary";
        }

        // 3. Construct the new search parameters
        const queryParams = new URLSearchParams({
          entityName:
            data.funderName ||
            data.publisherName ||
            data.institutionName ||
            actualShortName,
          shortName: data.shortName,
          entityId: data.agencyId || data.memberId || data.institutionId,
          publishersNum: "10",
          tab: tabParam,
          filterBy: "ALL",
        });

        // 4. Force a hard browser redirect instead of React Router's soft navigate
        const newUrl = `/${actualType}/publication-analytics?${queryParams.toString()}`;
        if (isMask) {
          sessionStorage.setItem("maskedEntityShortName", data.shortName);
        }
        window.location.replace(newUrl);
      } catch (error) {
        console.error("Legacy redirect failed:", error);
        setHasError(true);
      }
    };

    if (actualShortName) {
      fetchAndRedirect();
    } else {
      setHasError(true);
    }
  }, [actualType, actualShortName, location.hash, navigate]);

  if (hasError) {
    return <Navigate to="/page-not-found" replace />;
  }

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "50vh" }}
    >
      <div className="text-center">
        <Loader />
      </div>
    </div>
  );
};

export default LegacyRedirector;
